import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Row } from 'antd';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import ExportExtentionForm from '@app/components/apps/Export/ExportExtention/ExportExtentionForm';

export const EditExportExtension: React.FC = () => {
  const location = useLocation();
  const { id, export_id } = location.state || {};
  const { t } = useTranslation();
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('Edit Export-Extension');

  const { setBreadcrumb, clearHeaderButtons } = useHeader();

  const routes = [
    {
      path: '/export-extensions',
      breadcrumbName: 'ExportExtensions',
    },
    {
      path: '/edit-export-extension',
      breadcrumbName: currentBreadcrumName,
    },
  ];

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(currentBreadcrumName);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons, currentBreadcrumName]);

  return (
    <>
      <Row gutter={[16, 16]}>
        <ExportExtentionForm
          type="edit"
          editable={true}
          id={id}
          export_id={export_id}
          pageTitle={`Edit Export-Extention`}
          setCurrentBreadcrumName={setCurrentBreadcrumName}
        />
      </Row>
    </>
  );
};

export default EditExportExtension;
